import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { useApiDefaults } from 'hooks/useApiDefaults'
import { getProductFromUpcOrSlug, getProductsFromUPCs } from 'redux/actions'
import WeeklyAdsProduct from '../WeeklyAdsProduct'

export function Redners() {
  const divId = 'red-pepper-catalog'
  const apiDefaults = useApiDefaults()
  const [UPC, setUPC] = useState([])
  const [showPopup, setShowPopup] = useState(false)
  const [loading, setLoading] = useState(false)
  const [productInfo, setProductInfo] = useState()
  const togglePopup = () => setShowPopup(!showPopup)
  const [error, setError] = useState('')
  
  const storeList = useSelector(({ store }) => store.storeListData);
  const { ClientStoreId } = useApiDefaults();
  const [POSStoreId, setPOSStoreId] = useState(null)
  const [, setSearchParams] = useSearchParams()

  useEffect(() => {
    // remove "c" query param with hooks
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev)
      newParams.delete('c')
      return newParams
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const store = storeList?.find((store) => store.ClientStoreId == ClientStoreId)
    if (store?.POSStoreId) {
      setPOSStoreId(store.POSStoreId)
    }
  }, [storeList, ClientStoreId])

  useEffect(() => {
    if (!POSStoreId) {
      return
    }

    const injectedScripts = []

    const loadScripts = async () => {
      try {
        const script = document.createElement('script')
        script.src =
          'https://app.redpepper.digital/publications/redpepper.min.js'
        script.async = true

        script.onload = () => {
          if (window.redpepper) {
            window.redpepper.init(
              'https://app.redpepper.digital/', // `d`
              'red-pepper-catalog', // `e`
              4737, // f
              POSStoreId // g
            )
          }
        }
        injectedScripts.push(script)
        document.head.appendChild(script)
      } catch (error) {
        console.error('Error loading scripts:', error)
      }
    }

    loadScripts()

    function receiveUPC(event) {
      if (event.data.action === 'openProductView') {
        setUPC(
          event.data?.productSKU?.split(',')?.map(upc => sanitizeUPC(upc)) ?? []
        )
      }
    }
    window.addEventListener('message', receiveUPC)

    return () => {
      injectedScripts.forEach(s => {
        if (s.parentNode) {
          s.parentNode.removeChild(s)
        }
      })

      window.removeEventListener('message', receiveUPC)
    }
  }, [POSStoreId])

  useEffect(() => {
    getIframeData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [UPC])

  async function getIframeData() {
    try {
      setError('')
      setProductInfo(null)

      if (UPC.length === 0) {
        return
      }

      setLoading(true)

      let res
      if (UPC.length === 1) {
        res = await getProductFromUpcOrSlug({
          ...apiDefaults,
          upc: UPC[0],
          search: '',
          slug: '',
        })
      } else {
        res = await getProductsFromUPCs({
          ...apiDefaults,
          input_upcs: UPC,
        })
      }

      if (UPC.length > 1 && res.data.length === 1) {
        const slug = res.data[0]?.slug
        res = await getProductFromUpcOrSlug({
          ...apiDefaults,
          upc: '',
          search: '',
          slug: slug,
        })

      }

      const data = res.data
      const errorMsg = res.error

      setLoading(false)

      if (data) {
        setProductInfo(data)
      } else {
        setError(errorMsg)
      }

      setShowPopup(true)
    } catch (error) {
      console.error('❌ Error fetching product info:', error)
    } finally {
      setLoading(false)
    }
  }

  const isPopupVisible =
    !loading &&
    showPopup &&
    ((Array.isArray(productInfo) && productInfo?.length) || error)

  return (
    <div className='weekly-ad-product-popup'>
      {isPopupVisible && (
        <div className='popup-overlay' onClick={togglePopup}>
          <div className='popup-content' onClick={e => e.stopPropagation()}>
            <button className='close-button' onClick={togglePopup}>
              ×
            </button>
            <WeeklyAdsProduct productInfo={productInfo} error={error} />
          </div>
        </div>
      )}

      <div id={divId}> </div>
    </div>
  )
}

function sanitizeUPC(str) {
  if (str && str[0] === '0') {
    return str.slice(1)
  }
  return str
}